const CENTURY_THRESHOLD = 2000;

export const isQuarterFormat = (date: string): boolean =>
  /^Q[1-4](?:'?\d{2})?$/u.test(date);

export const getQuarterLabel = (quarter: string): string | null => {
  const quarterNum = parseInt(quarter.charAt(1), 10);
  if (Number.isNaN(quarterNum) || quarterNum < 1 || quarterNum > 4) {
    return null;
  }

  const hasYear = quarter.includes("'");
  if (!hasYear) {
    return `Quarter ${quarterNum}`;
  }

  const [, yearPart] = quarter.split("'");
  const year = parseInt(yearPart, 10);
  if (Number.isNaN(year)) {
    return null;
  }

  const fullYear = year < 100 ? CENTURY_THRESHOLD + year : year;
  return `Quarter ${quarterNum}, ${fullYear}`;
};
